import PropTypes from 'prop-types';
// @flow

import React, { Component } from 'react';
//import { RouteHandler } from 'react-router';
import _ from 'lodash';
import shallowCompare from 'react-addons-shallow-compare';
import Config from 'constants/Config';

import { Logger } from 'PMT/utils';
import Listener from 'PMT/flux/Listener';
import SdkConfiguration from 'PMT/utils/SdkConfiguration';

import RoutingEnum from 'constants/RoutingEnum';
import { Events } from 'constants';

import { RestaurantAction, ProAccountAction } from 'actions';

// -- stores
import { RestaurantStore, ProAccountStore, SessionStore, RouteStore } from 'stores';

// -- views
import Header from 'components/header/Header';
import Sidebar from 'components/sidebar/Sidebar';
import { AbstractComponent, Footer } from 'components';
// import { Footer } from 'components/footer';
import ContactModal from 'components/modal/ContactModal';

/**
 * @parent index.js
 */
class Layout extends AbstractComponent {

  static propTypes = {};

  state = {
    displayContactModal: false,

    /**
     * The current selected restaurant.
     */
    restaurant: null,

    /**
     * The current user's account.
     */
    meAccount: null,

    /**
     * Is set to true to allow us to reload the whole Layout.
     * Used when we change the restaurant.
     */
    reloadingLayout: false,

    /**
     * Used to know if we are just after the login
     * @type {Boolean}
     */
    onLogin: false
  };

  componentWillMount() {
    SdkConfiguration.setDomainUrl(`https://${Config.HOSTNAME}`);
  }

  componentDidMount() {
    RestaurantStore.addListeners(this.restaurantListeners);
    ProAccountStore.addListeners(this.proAccountListeners);

    SessionStore.addListener(Events.ON_LOGIN_SUCCESS, this.onLogin);

    this.loadAccount();
  }

  componentWillUnmount() {
    RestaurantStore.removeListeners(this.restaurantListeners);
    ProAccountStore.removeListeners(this.proAccountListeners);

    SessionStore.removeListener(Events.ON_LOGIN_SUCCESS, this.onLogin);
  }

  shouldComponentUpdate(nextProps, nextState) {
    return true;
    // return shallowCompare(this, nextProps, nextState);
  }

  loadAccount = () => {
    if (SessionStore.isLoggedIn()) {
      this.showLoading();

      ProAccountAction.retrieveMeAccount();
    }
  };

  onLogin = () => {
    this.showLoading();
    ProAccountAction.retrieveMeAccount();

    this.setState({
      onLogin: true
    });
  };

  //
  // Listeners
  //

  get restaurantListeners(): Array<Listener> {
    return [
      new Listener(Events.LOAD_RESTAURANT_SUCCESS, this.onRestaurantChange),
      new Listener(Events.UPDATE_RESTAURANT_SUCCESS, this.onRestaurantChange),
      new Listener(Events.RESTAURANT_CHANGE_SUCCESS, this.onRestaurantGroupChange),
      new Listener(Events.RESTAURANT_CHANGE_REQUEST, this.onRestaurantIsChanging),
    ];
  }

  get proAccountListeners(): Array<Listener> {
    return [
      new Listener(Events.PRO_ACCOUNT_GET_ME_SUCCESS, this.onLoadMe),
      new Listener(Events.PRO_ACCOUNT_GET_ME_FAILURE, this.onLoadMeError)
    ];
  }

  //
  // Events
  //

  onLoadMe = () => {
    try {
      const onLogin = this.state.onLogin;

      this.setState({
        restaurant: RestaurantStore.getRestaurant(),
        meAccount: ProAccountStore.getMeAccount(),
        loading: false,
        onLogin: false
      });

      if (onLogin) {
        RouteStore.redirectTo(RoutingEnum.DASHBOARD);
      }
    } catch (e) { console.error(e); }
  };

  onLoadMeError = () => {
    // TODO
  };

  /**
   * The selected restaurant is changing.
   * In order to avoid errors, we reload the layout.
   */
  onRestaurantIsChanging = () => {
    this.setState({
      reloadingLayout: true
    });
  }

  /**
   * Triggered when the user have changed the selected restaurant / restaurantsGroup
   * we have to reload the whole page.
   */
  onRestaurantGroupChange = () => {
    window.location.reload()
  };

  onRestaurantChange = () => {
    this.setState({
      restaurant: RestaurantStore.getRestaurant(),

      // wait for the other api call that retrieve the account
      loading: _.isNull(this.state.meAccount)
    });
  };

  //
  // events - contact modal
  //

  onDisplayContactModal = () => {
    this.setState({
      displayContactModal: true
    });
  };

  onHideContactModal = () => {
    this.setState({
      displayContactModal: false
    });
  };

  //
  // renderers
  //

  renderSidebar() {
    if (!SessionStore.isLoggedIn()) {
      return (null);
    }

    return (
      <Sidebar
        routes={this.props.routes}
      />
    );
  }

  renderLayout() {
    if (SessionStore.isLoggedIn()) {
      if (this.state.reloadingLayout === true
      || _.isNull(this.state.meAccount)
      || _.isNull(this.state.restaurant)
    ) {
        return this.renderOnLoadingContent();
      }
    }

    return (
      <div>
        <Header
          onDisplayContactModal={this.onDisplayContactModal}
          routes={this.props.routes}
        />

        <div className="container-fluid">
          <div className="row">

            <div className="col-sm-2 sidebar">
              {this.renderSidebar()}
            </div>

            <div id="page_wrapper" className="col-md-12 col-lg-10 col-lg-offset-2 main">
              {this.props.children}
            </div>

            {/* <Footer /> */}
          </div>

          <ContactModal
            show={this.state.displayContactModal}
            onHide={this.onHideContactModal}
          />

        </div>
      </div>
    );
  }

  render() {
    /**
    * Render the layout of our page. If an exception occured, we log it and send it to our tracker.
    */
    return (
      <div>
        {this.renderLoading()}
        {this.renderLayout()}
      </div>
    );

  }
}

export default Layout;



// WEBPACK FOOTER //
// ./scripts/pages/Layout.js